import { render, staticRenderFns } from "./loginBack.vue?vue&type=template&id=0fe410de&scoped=true"
import script from "./loginBack.vue?vue&type=script&lang=js"
export * from "./loginBack.vue?vue&type=script&lang=js"
import style0 from "./loginBack.vue?vue&type=style&index=0&id=0fe410de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe410de",
  null
  
)

export default component.exports